import * as moment from 'moment';
import { DateTimeConverter } from '../../../core/services/mapper/converters';

export class LeurreSearch {
    static jsonMap = {
        idLeurre: { key: 'idLeurre' },
        millesime: { key: 'millesime' },
        libelleTypeLeurre: { key: 'libelleTypeLeurre', optional: true, default: '' },
        dateCommission: { key: 'dateCommission', converter: new DateTimeConverter(), optional: true },
        libelleProduit: { key: 'libelleProduit', optional: true, default: '' },
        numeroCommission: { key: 'numeroCommission', optional: true, default: '' },
        numeroJury: { key: 'numeroJury' },
        numeroAnonymat: { key: 'numeroAnonymat', optional: true, default: '' },
        defauts: { key: 'defauts', default: () => [] },
        libelleConditionnement: { key: 'libelleConditionnement', optional: true, default: '' }
    };

    idLeurre: number;
    millesime: number;
    libelleTypeLeurre: string;
    dateCommission: moment.Moment;
    libelleProduit: string;
    numeroCommission: string;
    numeroJury: number;
    numeroAnonymat: string;
    defauts: string[];
    libelleConditionnement: string;
}
